import {useCity} from "../../../app/utils/use";
import {CITY_LIST} from "../../../app/utils/const";
import styles from '../../cleaning/panel/Panel.module.css';
import {Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCity} from "@fortawesome/free-solid-svg-icons";
import _ from 'lodash'

const CentralPanel = () => {

    const cityId = useCity();
    const city = _.find(CITY_LIST, {id: cityId});

    return (
        <div className={styles.CentralPanel}>
            <div className={styles.CentralPanelBody}>
                <Dropdown className={styles.Dropdown} id={styles['CityDropdown']}>
                    <Dropdown.Toggle variant="light">
                        <FontAwesomeIcon icon={faCity}/> {city ? city.name : ''}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {CITY_LIST.map((city) => (
                            <Dropdown.Item
                                href={'/onsite-drycleaning/map/?cityId=' + city.id}
                                key={'city-link-' + city.id}>
                                {city.name}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    );
};

export default CentralPanel;
